import React from 'react';
import { Box, Typography } from '@mui/material';
import { ROLES } from '../constants/roles';
import { useModuleViewAccess } from '../hooks/useModuleViewAccess';
import InventoryManagement from './store/InventoryManagement';
import WorkflowGuide from './common/WorkflowGuide';

const STORE_ACCESS_ROLES = [
  ROLES.STORE_EXECUTIVE,
  ROLES.STORE_INSPECTOR,
  ROLES.CA_MANAGER,
  ROLES.MRO_MANAGER,
  ROLES.CAMO_QM_MANAGER,
  ROLES.PLANNING_MANAGER,
  ROLES.ACCOUNTABLE_MANAGER,
  ROLES.SUPER_ADMIN
];

const InventoryPage = () => {
  const { hasAccess } = useModuleViewAccess('store-inventory', STORE_ACCESS_ROLES);

  if (!hasAccess) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Access Denied
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          You do not have permission to access Inventory.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Inventory
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Manage store inventory as a standalone page.
      </Typography>
      <WorkflowGuide variant="storeInventory" />
      <InventoryManagement />
    </Box>
  );
};

export default InventoryPage;
